/**
 * ReadOnlyBanner — shown when the active audit year is locked.
 *
 * Import and render at the top of any page that has year-scoped write actions.
 * (Processes, Controls, Test Runs, Issues…)
 */
import React from 'react';
import { Lock } from 'lucide-react';
import { useAuditYear } from '../contexts/AuditYearContext.tsx';

export default function ReadOnlyBanner() {
  const { selectedAuditYear } = useAuditYear();

  if (!selectedAuditYear?.is_locked) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center space-x-2 px-4 py-2 bg-amber-50 border border-amber-200 rounded-md text-sm text-amber-800"
    >
      <Lock className="h-4 w-4 flex-shrink-0 text-amber-500" />
      <span>
        <strong>{selectedAuditYear.name}</strong> is locked — this is a historical read-only view.
        Switch to an active audit year in the sidebar to make changes.
      </span>
    </div>
  );
}
